import React from "react"
import classnames from "classnames"
import { getSlimStyles } from "./utils"
import Button from "./button"

const RedButton = ({
  slim = false,
  className,
  onClick,
  order = 1,
  type = "button",
  children,
  submitting = false,
  disabled = false,
  rounding = "all",
}) => (
  <Button
    buttonClassName={classnames(
      "inline-flex items-center border border-gray-300 shadow-sm text-xs font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
      getSlimStyles(slim)
    )}
    className={className}
    disabled={disabled}
    onClick={onClick}
    order={order}
    rounding={rounding}
    submitting={submitting}
    type={type}
  >
    {children}
  </Button>
)

export default RedButton
